export type ClassValue = string | number | ClassRecord | ClassArray | undefined | null | boolean

export interface ClassRecord {
  [key: string]: boolean | undefined | null
}

export type ClassArray = Array<ClassValue>

function resolveValue(value: ClassValue): string {
  if (typeof value === "string") return value

  if (typeof value === "number") return String(value) || ""

  if (Array.isArray(value)) {
    return value.map(resolveValue).filter(Boolean).join(" ")
  }

  if (value !== null && typeof value === "object") {
    return Object.entries(value)
      .filter(([, v]) => Boolean(v))
      .map(([k]) => k)
      .join(" ")
  }

  return ""
}

/**
 * Joins class names together.
 *
 * Accepts strings, numbers, arrays, or objects mapping keys to booleans.
 * Falsy values (false, null, undefined) are ignored.
 *
 * @example
 * clsx("foo", "bar")                          // "foo bar"
 * clsx("foo", { bar: true, baz: false })      // "foo bar"
 * clsx(["foo", null, "bar"])                  // "foo bar"
 * clsx("foo", undefined, "bar")               // "foo bar"
 */
export function clsx(...args: ClassValue[]): string {
  return args.map(resolveValue).filter(Boolean).join(" ")
}
